let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9SoxW")).then(() => parcelRequire('cIJ7t'));